
import React, { Component } from 'react';
import { Switch, message, Card } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';

class BulkVisitors extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, current: {}};
    this.validateToken = this.validateToken.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getConfiguration();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getConfiguration() {
    axios.get(`${Configuration.apiServer}/api/v1/configuration`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data === null)
        return message.warning('Petición inválida')

      this.setState({current: resp.data});
    });
  }

  uploadFile(file) {
    console.log("Start uploading");
    console.log(file);

    const formData = new FormData();
    // formData.append("name", "");
    formData.append("file", file);

    axios
    .post(`${Configuration.apiServer}/api/v1/import-visitors`, formData, {headers: this.headers})
    .then((res) => {
      alert("Visitantes importados");
    })
    .catch((err) => alert("Hubo un error al importar el archivo"));
  }

  render() {
    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div>
            <h3 className="text-primary text-center" style={{ marginBottom: '0px' }}>Importación de visitantes</h3>
            <h6 className="text-muted text-center" style={{ marginBottom: '0px', display: 'block' }}>Solo se aceptan archivos en formato CSV</h6>
          </div>

          <br/>

          
          <div className="d-flex justify-content-center">
            <Card style={{ width: '50%', margin: '0px' }}>
              <input type="file" onChange={(e) => this.uploadFile(e.target.files[0])} />
            </Card>
          </div>
        </div>
      </div>
    );
  }

}

export default BulkVisitors;



// WEBPACK FOOTER //
// ./src/pages/admin/BulkVisitors.js